export async function getThreadInfoById(id: string): Promise<null> {
  return null;
}
